export const GIFT_CARD_TYPE = 1;
export const ADD_CREDIT = "1";
export const CHARGE_CREDIT = "2";
export const GIFT_CARD_ACCOUNT_DEFAULT_PAGE_SIZE = 10;
